export default __webpack_public_path__ + "static/media/Serviced_Delivery_Specialist_Role.980c0096.svg";